// Navigation for product-tabs swipe-mobile
if (!customElements.get('product-tabs-navigation')) {
  class ProductTabsNavigation extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        nextEl: '.product-tabs-btn-next',
        prevEl: '.product-tabs-btn-prev',
      };

      this.initNavigation();
    }

    initNavigation() {
      // Find buttons within this custom element
      const nextBtn = this.querySelector(this.selectors.nextEl);
      const prevBtn = this.querySelector(this.selectors.prevEl);

      if (!nextBtn || !prevBtn) return;

      // Get the active tab panel
      const getActivePanel = () => {
        // Find the active tab content (not hidden)
        const activeContent = this.querySelector('.tabs__content:not([hidden])');
        if (!activeContent) return null;

        // Look for grid-list or products-grid-wrap (swipe-mobile container)
        return activeContent.querySelector('grid-list, .products-grid-wrap');
      };

      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const activePanel = getActivePanel();
        if (activePanel) this.scrollNext(activePanel);
      });

      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const activePanel = getActivePanel();
        if (activePanel) this.scrollPrev(activePanel);
      });

      // Update scroll container when tabs change
      this.addEventListener('click', (e) => {
        if (e.target.closest('.tabs__tab')) {
          // Small delay to let the tab content show
          setTimeout(() => {
            const activePanel = getActivePanel();
            if (activePanel) {
              // Find the actual scroll container
              const scrollContainer = activePanel.classList.contains('swipe-mobile')
                ? activePanel
                : activePanel.querySelector('.swipe-mobile');

              if (scrollContainer) {
                // Reset scroll position when switching tabs
                scrollContainer.scrollLeft = 0;
              }
            }
          }, 50);
        }
      });
    }

    scrollNext(container) {
      if (!container) return;

      // Find the actual scroll container - could be the element itself or a child
      const scrollContainer = container.classList.contains('swipe-mobile')
        ? container
        : container.querySelector('.swipe-mobile');

      if (!scrollContainer) return;

      const item = scrollContainer.querySelector('.f-column');
      if (!item) return;

      const scrollAmount = item.offsetWidth;
      const gap = parseInt(getComputedStyle(scrollContainer).columnGap || '0');

      scrollContainer.scrollBy({ left: scrollAmount + gap, behavior: 'smooth' });
    }

    scrollPrev(container) {
      if (!container) return;

      // Find the actual scroll container - could be the element itself or a child
      const scrollContainer = container.classList.contains('swipe-mobile')
        ? container
        : container.querySelector('.swipe-mobile');

      if (!scrollContainer) return;

      const item = scrollContainer.querySelector('.f-column');
      if (!item) return;

      const scrollAmount = item.offsetWidth;
      const gap = parseInt(getComputedStyle(scrollContainer).columnGap || '0');

      scrollContainer.scrollBy({ left: -(scrollAmount + gap), behavior: 'smooth' });
    }
  }

  customElements.define('product-tabs-navigation', ProductTabsNavigation);
}
